module.exports = __webpack_public_path__ + "img/cateicon5_a.439fa3f2.svg";